import _get from 'lodash/get';
import axios from 'axios';
import Page from '../../lib/page';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import * as types from '../constants/ActionTypes';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const emailByPassPage = 'emailByPassPage';

function requestIDIContactOptions() {
  return {
    type: types.REQUEST_IDI_CONTACT_OPTIONS,
  };
}

function receivedIDIContactOptionsError() {
  return {
    type: types.RECEIVE_IDI_CONTACT_OPTIONS_ERROR,
  };
}

// Passing IDI channels(contact options) to redux state
function receivedIDIContactOptions(IDIChannels) {
  return {
    type: types.RECEIVE_IDI_CONTACT_OPTIONS_RESPONSE,
    payload: IDIChannels,
  };
}

// Send IDI Post request to IDI server
function userSelectionPostRequest(kanaCode, topicName) {
  return axios.post('/smarthelp/update-user-selection', {
    _csrf: Page.getCSRFtoken(),
    topicId: kanaCode,
    topicName,
  });
}

function joinContactOptions(contactChannels = []) {
  if (!Array.isArray(contactChannels)) {
    return '';
  }

  let temp = '';
  const tempChannelsArr = contactChannels.map((contactType) => {
    temp = ((contactType && contactType.type) || '').toLocaleLowerCase();

    // Mapping `contactType.type` to match user story.
    switch (temp) {
      case 'callus' :
        temp = 'call-us';
        break;
      case 'email' :
        temp = 'email-us';
        break;
      case 'seller' :
        temp = 'resolution';
        break;
      default:
        break;
    }
    return temp;
  });

  return tempChannelsArr.join('|');
}

function setFptiForL2AndL3FinalIntents(state = {}) {
  const { topicSelect, topicTree, contactChannels } = state;

  const treeLayer = _get(topicSelect, 'layer', null);
  const l2SubTopics = (treeLayer === 2) ? _get(topicTree, 'topicTreeSelectionL2.sub_topics', []) : [];
  const idiContactChannels = _get(contactChannels, 'IDIChannels', []);
  let topicRefId;
  let parsedChannels = '';

  // Let's calculate the right topicRefId
  if (treeLayer === 2) {
    topicRefId = _get(topicSelect, 'topicRef.layer2', 0);
  } else if (treeLayer === 3) {
    topicRefId = _get(topicSelect, 'topicRef.layer3', 0);
  }

  // L2 & L3 final intent FPTI logic
  if (treeLayer === 2 && !l2SubTopics.length && topicRefId) {  // Final L2 intent
    parsedChannels = joinContactOptions(idiContactChannels) || '';
    trackPage({ id: 'contactUsPage', link: `smarthelp-select-topic-L2|${topicRefId}|final|${parsedChannels}` });
  } else if (treeLayer === 3) { // Final L3 intent
    const prevL3 = _get(state, 'topicTree.topicTreeSelectionL3.ref_id', null);
    parsedChannels = joinContactOptions(idiContactChannels) || '';

    if (prevL3 && topicRefId) {
      trackPage({ id: 'contactUsPage', link: `smarthelp-switch-topic-L3|${prevL3}|${topicRefId}|final|${parsedChannels}` });
    }
    trackPage({ id: 'contactUsPage', link: `smarthelp-select-topic-L3|${topicRefId}|final|${parsedChannels}` });
  }
}

// Update User Selection for both Login and Logout users
function updateUserSelection(id) {
  return (dispatch, getState) => {
    const { topicName } = getState().selectResult.topicTreeSelectResult;
    const kanaCode = id === emailByPassPage ? getState().emailNoIntent.kanaCode : getState().emailForm.kanaCode;
    trackLink({ id, link: `smarthelp-topic-update-idi|${kanaCode}|` });

    const postRequest = userSelectionPostRequest(kanaCode, topicName);

    // Using remote config to control IDI contact options display logic
    if (Page.getIsIDIContactOptions()) {
      postRequest.then((response) => {
        dispatch(requestIDIContactOptions());
        const IDIChannels = _get(response, 'data');
        if (Array.isArray(IDIChannels) && IDIChannels.length > 0) {
          dispatch(receivedIDIContactOptions(IDIChannels));
          setFptiForL2AndL3FinalIntents(getState());
        } else {
          dispatch(receivedIDIContactOptionsError());
        }
      });
      postRequest.catch(() => dispatch(receivedIDIContactOptionsError()));
    }
    return postRequest;
  };
}

module.exports = {
  updateUserSelection,
};
